import { FieldSet } from "@components/ui/field";
import KeywordTargetingForm from "./KeywordTargetingForm";
import NegativeKeywordTargetingForm from "./NegativeKeywordTargetingForm";
import { useStageInit } from "@hooks/useStageInit";

export default function KeywordsForm() {
  useStageInit("keywords");

  return (
    <div className="border border-neutral-300 border-t-0 rounded-b-2xl bg-white" data-testid="keywords-form">
      <div className="py-8 pl-9 pr-[97px] flex flex-col gap-10">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-0.5">
            <h2 className="text-lg font-semibold leading-[22px]">Keyword Targeting</h2>
            <p className="text-xs text-base-300">
              These are the search terms that will trigger your ad. We've picked these based on what
              your customers are likely searching for — remove any that don't fit, or add ones we missed.
            </p>
          </div>
          <FieldSet>
            <KeywordTargetingForm />
          </FieldSet>
        </div>
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-0.5">
            <h2 className="text-lg font-semibold leading-[22px]">Negative Keywords</h2>
            <p className="text-xs text-base-300">
              Negative keywords help protect your budget. They filter out users who are looking for free, DIY, or
              general information - tire kickers who aren't ready to buy.
            </p>
          </div>
          <FieldSet>
            <NegativeKeywordTargetingForm />
          </FieldSet>
        </div>
      </div>
    </div>
  );
}
